import { v4 as uuid, validate as isUuid, v3, v1 } from 'uuid'
import { WappMode } from '@weblite-wapps/protocol'

const objectIdRegExp = new RegExp(/^[0-9a-fA-F]{24}$/)
const isObjectId = (id: string) => objectIdRegExp.test(id)

const slashJoin = (...args: string[]) => args.filter(Boolean).join('/')

const API_V2_PREFIX = 'APIv2'

export const generateWappSessionId = () => uuid() as string

export const generateWappElementName = ({
  wappSessionId,
  wappId,
  wisId = null,
  mode,
}: {
  wappSessionId: string
  wappId: string
  wisId?: string
  mode: WappMode
}) =>
  // NOTE: Old wapps' wapp-ids are ObjectId but new wapps' wapp-ids are NOT. We use this difference to distinguish them
  slashJoin(
    isObjectId(wappId) ? API_V2_PREFIX : '',
    wappSessionId,
    wappId,
    mode,
    wisId,
  )
